import styled from "styled-components";
import { getContrastTextColorRGB } from "utils/getContrastTextColor";

export const Status = styled.span<{ color: string, marginLeft?: string, size?: string }>`
  /* background: rgba(${(props) => props.color});
  color: rgb(${(props) => getContrastTextColorRGB(props.color, true)}); */

  background: rgba(${(props) => props.color}, 0.15);
  color: rgb(${(props) => props.color === "255,255,255" ? "black" : props.color});

  /* font-size: ${(props) => props.size === "small" ? "12px" : "14px"};
  padding: ${(props) => props.size === "small" ? "2px 8px" : "4px 12px"};
  font-weight: ${(props) => props.size === "small" ? "600" : "500"}; */
  font-size: 12px;
  padding: 2px 8px;
  font-weight: 800;
  border-radius: 5px;
  white-space: nowrap;
  width: auto;
  margin-left: ${(props) => props.marginLeft || "0"};
  border: ${(props) => `1px solid ${
    props.color === "white" || props.color === "255,255,255"
    ? "#bebebe" : "#e5e7eb"
  }`};
  /* border: 1px solid #bebebe; */
`;
